import { render, staticRenderFns } from "./TaRadio.vue?vue&type=template&id=2ab741c2&"
import script from "./TaRadio.vue?vue&type=script&lang=js&"
export * from "./TaRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports